import { render, staticRenderFns } from "./SoftwareMFA.vue?vue&type=template&id=55a1ddbe&scoped=true"
import script from "./SoftwareMFA.vue?vue&type=script&lang=js"
export * from "./SoftwareMFA.vue?vue&type=script&lang=js"
import style0 from "./SoftwareMFA.vue?vue&type=style&index=0&id=55a1ddbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a1ddbe",
  null
  
)

export default component.exports